var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("证件详情")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pageTab" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("div", [
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("用户名：" + _vm._s(_vm.info.name)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("手机号：" + _vm._s(_vm.info.phone)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("证件类型：" + _vm._s(_vm.info.careerTypeName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("证件等级：" + _vm._s(_vm.info.levelTypeName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("证件编号：" + _vm._s(_vm.info.certNumber)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "infoItem",
                    staticStyle: { display: "flex", "align-items": "center" },
                  },
                  [
                    _c("el-image", {
                      staticStyle: {
                        width: "200px",
                        height: "300px",
                        "margin-right": "30px",
                      },
                      attrs: {
                        src: _vm.secureImageUrl,
                        alt: "",
                        "preview-src-list": [_vm.secureImageUrl],
                      },
                    }),
                    _vm._v(" "),
                    _c("el-image", {
                      staticStyle: { width: "200px", height: "300px" },
                      attrs: {
                        src: _vm.secureImageUrl1,
                        alt: "",
                        "preview-src-list": [_vm.secureImageUrl1],
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }